export default __webpack_public_path__ + "static/cardImg2-07e3c2a825d54b3f8cfe77b6a93fb240.webp";